<script setup></script>

<template>
  <footer id="footer2">
    <div class="com_inner1 clearfix">
      <h2 class="logo1">
        <img src="/front/assets/common/img/logo2.png" alt="共創未来グループ">
      </h2>
      <p class="copyright1">Copyright &copy; TOHO HOLDINGS CO., LTD.</p>
    </div>
  </footer>
</template>